/**
 * Tools Configuration
 * Available tools for the public homepage and their status
 */

import SearchIcon from '@mui/icons-material/Search';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DataObjectIcon from '@mui/icons-material/DataObject';
import CodeIcon from '@mui/icons-material/Code';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LockIcon from '@mui/icons-material/Lock';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import BuildIcon from '@mui/icons-material/Build';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import MinimizeIcon from '@mui/icons-material/Minimize';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import ContrastIcon from '@mui/icons-material/Contrast';
import TagIcon from '@mui/icons-material/Tag';
import ShareIcon from '@mui/icons-material/Share';
import DescriptionIcon from '@mui/icons-material/Description';
import TitleIcon from '@mui/icons-material/Title';
import SecurityIcon from '@mui/icons-material/Security';
import ArticleIcon from '@mui/icons-material/Article';
import TableChartIcon from '@mui/icons-material/TableChart';
import TransformIcon from '@mui/icons-material/Transform';
import PaletteIcon from '@mui/icons-material/Palette';
import GradientIcon from '@mui/icons-material/Gradient';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventIcon from '@mui/icons-material/Event';
import CalculateIcon from '@mui/icons-material/Calculate';
import StraightenIcon from '@mui/icons-material/Straighten';
import ImageIcon from '@mui/icons-material/Image';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import PersonIcon from '@mui/icons-material/Person';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import AddLinkIcon from '@mui/icons-material/AddLink';
import TableViewIcon from '@mui/icons-material/TableView';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FolderIcon from '@mui/icons-material/Folder';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import CampaignIcon from '@mui/icons-material/Campaign';
import TwitterIcon from '@mui/icons-material/Twitter';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import TimerIcon from '@mui/icons-material/Timer';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';

export const TOOLS_CONFIG = [
    {
        id: 'web-analyser',
        icon: SearchIcon,
        title: 'Web Analyzer',
        available: true,
        description: 'Analyze website performance, SEO, and security',
        route: '/web-analyser',
        requiresUrlInput: true,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'password-generator',
        icon: VpnKeyIcon,
        title: 'Password Generator',
        available: true,
        description: 'Generate secure, random passwords with customizable options',
        route: '/password-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'json-formatter',
        icon: DataObjectIcon,
        title: 'JSON Formatter',
        available: true,
        description: 'Format and validate JSON with syntax highlighting',
        route: '/json-formatter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'base64-encoder-decoder',
        icon: CodeIcon,
        title: 'Base64 Tool',
        available: true,
        description: 'Encode text to Base64 or decode Base64 to text instantly',
        route: '/base64-encoder-decoder',
        requiresUrlInput: false,
        category: 'Text Processing',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'text-case-converter',
        icon: TextFieldsIcon,
        title: 'Text Case Converter',
        available: true,
        description: 'Convert text between uppercase, lowercase, title case, and more',
        route: '/text-case-converter',
        requiresUrlInput: false,
        category: 'Text Processing',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    // HIGH IMPORTANCE TOOLS
    {
        id: 'qr-code-generator',
        icon: QrCodeIcon,
        title: 'QR Code Generator',
        available: true,
        description: 'Generate QR codes from text/URL with download option',
        route: '/qr-code-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'color-picker',
        icon: ColorLensIcon,
        title: 'Color Picker',
        available: true,
        description: 'Pick colors with HEX, RGB, HSL, HSV values',
        route: '/color-picker',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'material-design-colors',
        icon: ColorLensIcon,
        title: 'Material Design Colors',
        available: true,
        description: 'Browse Material Design color palette with HEX and RGB values',
        route: '/material-design-colors',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'font-pairing-tool',
        icon: ColorLensIcon,
        title: 'Font Pairing Tool',
        available: true,
        description: 'Find and preview font pairings for your designs',
        route: '/font-pairing-tool',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'hash-generator',
        icon: LockIcon,
        title: 'Hash Generator',
        available: true,
        description: 'Generate MD5, SHA1, SHA256, SHA512 hashes',
        route: '/hash-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'unix-timestamp-converter',
        icon: AccessTimeIcon,
        title: 'Unix Timestamp Converter',
        available: true,
        description: 'Convert Unix timestamps to dates and vice versa',
        route: '/unix-timestamp-converter',
        requiresUrlInput: false,
        category: 'Online Calculators',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'gas-oil-mass-volume-converter',
        icon: LocalGasStationIcon,
        title: 'Gas Oil Mass Volume Converter',
        available: true,
        description: 'Convert metric tonnes of gas oil to cubic meters with ASTM D1250 correction factors',
        route: '/gas-oil-mass-volume-converter',
        requiresUrlInput: false,
        category: 'Petroleum Engineering',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'fuel-oil-mass-volume-converter',
        icon: LocalGasStationIcon,
        title: 'Fuel Oil Mass Volume Converter',
        available: true,
        description: 'Convert metric tonnes of fuel oil to cubic meters with ASTM D1250 correction factors',
        route: '/fuel-oil-mass-volume-converter',
        requiresUrlInput: false,
        category: 'Petroleum Engineering',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'uuid-generator',
        icon: FingerprintIcon,
        title: 'UUID Generator',
        available: true,
        description: 'Generate UUIDs (v1, v4)',
        route: '/uuid-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'utm-builder',
        icon: BuildIcon,
        title: 'UTM Builder',
        available: true,
        description: 'Build URLs with UTM parameters for marketing',
        route: '/utm-builder',
        requiresUrlInput: false,
        category: 'URL Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'url-encoder-decoder',
        icon: FormatColorTextIcon,
        title: 'Text Encoder/Decoder',
        available: true,
        description: 'Encode/decode URL strings and HTML entities',
        route: '/url-encoder-decoder',
        requiresUrlInput: false,
        category: 'URL Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'image-studio',
        icon: ImageIcon,
        title: 'Image Studio',
        available: true,
        description: 'Comprehensive image processing: transform, optimize, encode, analyze, and more',
        route: '/image-studio',
        requiresUrlInput: false,
        category: 'Media Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: true,
    },
    {
        id: 'code-formatter',
        icon: CodeIcon,
        title: 'Code Formatter',
        available: true,
        description: 'Format code (JavaScript, CSS, HTML, JSON)',
        route: '/code-formatter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'code-minifier',
        icon: MinimizeIcon,
        title: 'Code Minifier',
        available: true,
        description: 'Minify JavaScript, CSS, HTML',
        route: '/code-minifier',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'regex-tester',
        icon: FindReplaceIcon,
        title: 'Regex Tester',
        available: true,
        description: 'Test regular expressions with live matching',
        route: '/regex-tester',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'color-contrast-checker',
        icon: ContrastIcon,
        title: 'Color Contrast Checker',
        available: true,
        description: 'Check WCAG contrast ratios for accessibility',
        route: '/color-contrast-checker',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'meta-tags-generator',
        icon: TagIcon,
        title: 'Meta Tags Generator',
        available: true,
        description: 'Generate optimized meta tags (title, description, OG)',
        route: '/meta-tags-generator',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'csp-generator',
        icon: TagIcon,
        title: 'CSP Generator',
        available: true,
        description: 'Generate Content Security Policy (CSP) headers',
        route: '/csp-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'open-graph-tags-generator',
        icon: ShareIcon,
        title: 'Open Graph Tags Generator',
        available: true,
        description: 'Generate OG tags for social sharing',
        route: '/open-graph-tags-generator',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'meta-description-generator',
        icon: DescriptionIcon,
        title: 'Meta Description Generator',
        available: true,
        description: 'Generate meta descriptions with character count',
        route: '/meta-description-generator',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'title-tag-optimizer',
        icon: TitleIcon,
        title: 'Title Tag Optimizer',
        available: true,
        description: 'Optimize title tags with length validation',
        route: '/title-tag-optimizer',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'password-strength-checker',
        icon: SecurityIcon,
        title: 'Password Strength Checker',
        available: true,
        description: 'Check password strength with visual indicator',
        route: '/password-strength-checker',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    // MEDIUM IMPORTANCE TOOLS
    {
        id: 'lorem-ipsum-generator',
        icon: ArticleIcon,
        title: 'Lorem Ipsum Generator',
        available: true,
        description: 'Generate placeholder text',
        route: '/lorem-ipsum-generator',
        requiresUrlInput: false,
        category: 'Text Processing',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'json-minifier',
        icon: DataObjectIcon,
        title: 'JSON Minifier',
        available: true,
        description: 'Minify JSON',
        route: '/json-minifier',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'json-to-csv-converter',
        icon: TableChartIcon,
        title: 'JSON to CSV Converter',
        available: true,
        description: 'Convert JSON to CSV format',
        route: '/json-to-csv-converter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'csv-to-json-converter',
        icon: TransformIcon,
        title: 'CSV to JSON Converter',
        available: true,
        description: 'Convert CSV to JSON (small files)',
        route: '/csv-to-json-converter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'json-to-xml-converter',
        icon: TransformIcon,
        title: 'JSON to XML Converter',
        available: true,
        description: 'Convert JSON to XML',
        route: '/json-to-xml-converter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'xml-to-json-converter',
        icon: TransformIcon,
        title: 'XML to JSON Converter',
        available: true,
        description: 'Convert JSON to XML',
        route: '/xml-to-json-converter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'color-converter',
        icon: PaletteIcon,
        title: 'Color Converter',
        available: true,
        description: 'Convert between HEX, RGB, HSL, HSV, CMYK',
        route: '/color-converter',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'color-shades-generator',
        icon: GradientIcon,
        title: 'Color Shades Generator',
        available: true,
        description: 'Generate color shades and tints',
        route: '/color-shades-generator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'color-palette-generator',
        icon: GradientIcon,
        title: 'Color Palette Generator',
        available: true,
        description: 'Generate color palettes from images or create manually',
        route: '/color-palette-generator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'gradient-generator',
        icon: GradientIcon,
        title: 'Gradient Generator',
        available: true,
        description: 'Generate CSS gradients',
        route: '/gradient-generator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'css-animation-generator',
        icon: GradientIcon,
        title: 'CSS Animation Generator',
        available: true,
        description: 'Generate CSS animations with keyframes and live preview',
        route: '/css-animation-generator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'box-shadow-generator',
        icon: GradientIcon,
        title: 'Box Shadow Generator',
        available: true,
        description: 'Generate CSS box-shadow with visual preview',
        route: '/box-shadow-generator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false,
    },
    {
        id: 'timezone-converter',
        icon: ScheduleIcon,
        title: 'Timezone Converter',
        available: true,
        description: 'Convert between timezones',
        route: '/timezone-converter',
        requiresUrlInput: false,
        category: 'Online Calculators',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'date-formatter',
        icon: EventIcon,
        title: 'Date Formatter',
        available: true,
        description: 'Format dates in various formats',
        route: '/date-formatter',
        requiresUrlInput: false,
        category: 'Online Calculators',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'number-base-converter',
        icon: CalculateIcon,
        title: 'Number Base Converter',
        available: true,
        description: 'Convert between binary, decimal, hex, octal',
        route: '/number-base-converter',
        requiresUrlInput: false,
        category: 'Converters',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'unit-converter',
        icon: StraightenIcon,
        title: 'Unit Converter',
        available: true,
        description: 'Convert between units (length, weight, temperature)',
        route: '/unit-converter',
        requiresUrlInput: false,
        category: 'Converters',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'base64-to-image',
        icon: PhotoLibraryIcon,
        title: 'Base64 to Image',
        available: true,
        description: 'Convert Base64 to images',
        route: '/base64-to-image',
        requiresUrlInput: false,
        category: 'Media Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'syntax-highlighter',
        icon: CodeOffIcon,
        title: 'Syntax Highlighter',
        available: true,
        description: 'Highlight syntax of code',
        route: '/syntax-highlighter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'user-agent-parser',
        icon: PersonIcon,
        title: 'User Agent Parser',
        available: true,
        description: 'Parse user agent strings',
        route: '/user-agent-parser',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'ulid-generator',
        icon: ShuffleIcon,
        title: 'ULID Generator',
        available: true,
        description: 'Generate ULIDs',
        route: '/ulid-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'guid-generator',
        icon: FingerprintIcon,
        title: 'GUID Generator',
        available: true,
        description: 'Generate GUIDs',
        route: '/guid-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'random-string-generator',
        icon: ShuffleIcon,
        title: 'Random String Generator',
        available: true,
        description: 'Generate random strings',
        route: '/random-string-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'barcode-generator',
        icon: QrCode2Icon,
        title: 'Barcode Generator',
        available: true,
        description: 'Generate barcodes (client-side)',
        route: '/barcode-generator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'url-parser',
        icon: LanguageOutlinedIcon,
        title: 'URL Parser',
        available: true,
        description: 'Parse URLs into components',
        route: '/url-parser',
        requiresUrlInput: false,
        category: 'URL Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'url-builder',
        icon: AddLinkIcon,
        title: 'URL Builder',
        available: true,
        description: 'Build URLs with query parameters',
        route: '/url-builder',
        requiresUrlInput: false,
        category: 'URL Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'utm-parser',
        icon: BuildIcon,
        title: 'UTM Parser',
        available: true,
        description: 'Parse UTM parameters from URLs',
        route: '/utm-parser',
        requiresUrlInput: false,
        category: 'URL Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'csv-viewer',
        icon: TableViewIcon,
        title: 'CSV Viewer',
        available: true,
        description: 'View CSV files in table format',
        route: '/csv-viewer',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'json-viewer',
        icon: VisibilityIcon,
        title: 'JSON Viewer',
        available: true,
        description: 'View JSON files in tree format',
        route: '/json-viewer',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'file-hash-calculator',
        icon: FolderIcon,
        title: 'File Hash Calculator',
        available: true,
        description: 'Calculate file hashes (client-side)',
        route: '/file-hash-calculator',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'robots-txt-generator',
        icon: SmartToyIcon,
        title: 'Robots.txt Generator',
        available: true,
        description: 'Generate robots.txt files',
        route: '/robots-txt-generator',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'schema-markup-generator',
        icon: SmartToyIcon,
        title: 'Schema Markup Generator',
        available: true,
        description: 'Generate structured data markup',
        route: '/schema-markup-generator',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'twitter-card-generator',
        icon: TwitterIcon,
        title: 'Twitter Card Generator',
        available: true,
        description: 'Generate Twitter Card meta tags',
        route: '/twitter-card-generator',
        requiresUrlInput: false,
        category: 'Digital Marketing',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'utm-campaign-builder',
        icon: CampaignIcon,
        title: 'UTM Campaign Builder',
        available: true,
        description: 'Build UTM tracking URLs',
        route: '/utm-campaign-builder',
        requiresUrlInput: false,
        category: 'URL Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'jwt-decoder',
        icon: LockIcon,
        title: 'JWT Decoder',
        available: true,
        description: 'Decode JWT tokens',
        route: '/jwt-decoder',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'yaml-to-json-converter',
        icon: TransformIcon,
        title: 'YAML to JSON Converter',
        available: true,
        description: 'Convert YAML to JSON',
        route: '/yaml-to-json-converter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'json-to-yaml-converter',
        icon: TransformIcon,
        title: 'JSON to YAML Converter',
        available: true,
        description: 'Convert JSON to YAML',
        route: '/json-to-yaml-converter',
        requiresUrlInput: false,
        category: 'Developer Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'timer-tool',
        icon: TimerIcon,
        title: 'Timer Tool',
        available: true,
        description: 'Countdown timer, stopwatch, and interval timer with sound notifications',
        route: '/timer-tool',
        requiresUrlInput: false,
        category: 'Online Calculators',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'date-calculator',
        icon: EventAvailableIcon,
        title: 'Date Calculator',
        available: true,
        description: 'Calculate age, business days, and deadlines',
        route: '/date-calculator',
        requiresUrlInput: false,
        category: 'Online Calculators',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'random-number-generator',
        icon: ShuffleIcon,
        title: 'Random Number Generator',
        available: true,
        description: 'Generate random numbers with range',
        route: '/random-number-generator',
        requiresUrlInput: false,
        category: 'General',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'border-radius-generator',
        icon: BorderColorIcon,
        title: 'Border Radius Generator',
        available: true,
        description: 'Generate border radius',
        route: '/border-radius-generator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'brand-color-extractor',
        icon: ColorLensIcon,
        title: 'Brand Color Extractor',
        available: true,
        description: 'Extract dominant colors from images',
        route: '/brand-color-extractor',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'csv-editor',
        icon: TableChartIcon,
        title: 'CSV Editor',
        available: true,
        description: 'Edit CSV files online',
        route: '/csv-editor',
        requiresUrlInput: false,
        category: 'Data Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'color-blindness-simulator',
        icon: ContrastIcon,
        title: 'Color Blindness Simulator',
        available: true,
        description: 'Simulate color blindness views',
        route: '/color-blindness-simulator',
        requiresUrlInput: false,
        category: 'Design Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'data-processor',
        icon: BuildIcon,
        title: 'Data Processor',
        available: true,
        description: 'Anonymize, clean, merge, and split data',
        route: '/data-processor',
        requiresUrlInput: false,
        category: 'Data Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'json-to-excel-converter',
        icon: TableChartIcon,
        title: 'JSON to Excel Converter',
        available: true,
        description: 'Convert JSON to Excel',
        route: '/json-to-excel-converter',
        requiresUrlInput: false,
        category: 'Data Tools',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    },
    {
        id: 'text-diff-tool',
        icon: CompareArrowsIcon,
        title: 'Text Diff Tool',
        available: true,
        description: 'Compare two texts and highlight differences',
        route: '/text-diff-tool',
        requiresUrlInput: false,
        category: 'Text Processing',
        visibility: 'public',
        version: 'beta',
        is_featured: false
    }
];

/**
 * Get tool by ID
 * @param {string} toolId - The tool ID
 * @returns {Object|null} - Tool configuration or null if not found
 */
export const getToolById = (toolId) => {
    return TOOLS_CONFIG.find(tool => tool.id === toolId) || null;
};

/**
 * Get available tools only
 * @returns {Array} - Array of available tools
 */
export const getAvailableTools = () => {
    return TOOLS_CONFIG.filter(tool => tool.available);
};

